import { Component } from '@verndale/core';

class Rtf extends Component {
  private tableShowMore: string = 'Show More';
  private tableShowLess: string = 'Show Less';
  private tableRows: number = 6;

  setupDefaults() {
    this.dom = {
      tables: this.el?.querySelectorAll('table') || []
    };
  }

  constructor(el: HTMLElement) {
    super(el);
    this.init();
  }

  addListeners() {}

  init() {
    const tableShowMore = this.el?.getAttribute('data-label-table-show-more');
    const tableShowLess = this.el?.getAttribute('data-label-table-show-less');
    const tableRows = this.el?.getAttribute('data-table-rows');

    if (tableShowMore) {
      this.tableShowMore = tableShowMore;
    }

    if (tableShowLess) {
      this.tableShowLess = tableShowLess;
    }

    if (tableRows) {
      const parsedRows = parseInt(tableRows, 10);
      if (!isNaN(parsedRows)) {
        this.tableRows = parsedRows;
      }
    }

    (this.dom.tables as NodeListOf<HTMLTableElement>)?.forEach((table: HTMLTableElement) => {
      this.loadMoreTable(table);
    });
  }

  loadMoreTable(table: HTMLTableElement) {
    const rows = table.querySelectorAll('tr');
    const rowsArray = Array.from(rows);
    let rowsWithoutThead = rowsArray.filter(row => !row.closest('thead'));

    if (rowsWithoutThead.length > 0 && rowsWithoutThead[0].querySelectorAll('th').length > 0) {
      rowsWithoutThead = rowsWithoutThead.slice(1);
    }

    const tableScroll = document.createElement('div');
    tableScroll.classList.add('rtf__table-scroll');

    table.parentNode?.insertBefore(tableScroll, table);
    tableScroll.appendChild(table);

    if (this.tableRows === 0 || rowsWithoutThead.length <= this.tableRows) return;

    const tableWrapper = document.createElement('div');
    tableWrapper.classList.add('rtf__table-wrapper');
    tableScroll.parentNode?.insertBefore(tableWrapper, tableScroll);
    tableWrapper.appendChild(tableScroll);

    rowsWithoutThead.forEach((row, index) => {
      if (index >= this.tableRows) {
        row.classList.add('rtf__table-row--hidden');
      }
    });

    const showMore = document.createElement('button');
    showMore.setAttribute('type', 'button');
    showMore.classList.add('btn', 'btn--outline', 'table__show-more');
    showMore.textContent = this.tableShowMore;
    tableWrapper.appendChild(showMore);

    let isShowingMore = false;

    showMore.addEventListener('click', e => {
      e?.preventDefault();
      showMore.blur();

      if (isShowingMore) {
        rowsWithoutThead.forEach((row, index) => {
          if (index >= this.tableRows) {
            row.classList.add('rtf__table-row--hidden');
          }
        });
        showMore.textContent = this.tableShowMore;
      } else {
        rowsWithoutThead.forEach(row => {
          row.classList.remove('rtf__table-row--hidden');
        });
        showMore.textContent = this.tableShowLess;
      }
      isShowingMore = !isShowingMore;
    });
  }
}

export default Rtf;
